import { Dispatch } from 'react';
import {
  decrementActiveCalls,
  incrementActiveCalls
} from '../../redux/loading.state';
import { ReactQueryHandlerOptions } from './reactQuery.interfaces';
import { useErrorHandler } from './useErrorhandler';

export function useQueryHandler<T>(
  queryFunction: Function,
  dispatch: Dispatch<any>,
  apiHandlerOptions?: ReactQueryHandlerOptions<T>
) {
  const errorHandler = useErrorHandler(apiHandlerOptions);

  return (queryFunctionArgs: any) => {
    const queryFnResult = queryFunction(...queryFunctionArgs);

    if ('then' in queryFnResult) {
      if (apiHandlerOptions?.useLoadingIndicator) {
        dispatch(incrementActiveCalls());
      }
      return queryFnResult
        .catch((error: any) => {
          errorHandler(error);
          throw error;
        })
        .finally(() => {
          if (apiHandlerOptions?.useLoadingIndicator) {
            dispatch(decrementActiveCalls());
          }
        });
    }

    return queryFnResult;
  };
}
